import React, { useState } from 'react';
import { FiChevronRight } from 'react-icons/fi';
import './FAQSection.css';

function FAQSection() {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: 'Como posso verificar a cobertura em minha área?',
      answer: 'Você pode consultar a cobertura pelo WhatsApp ou pela página de contato. Nossa equipe confirma o endereço e indica o melhor plano disponível.',
    },
    {
      question: 'Quais velocidades de internet vocês oferecem?',
      answer: 'Trabalhamos com planos de 400 Mega, 600 Mega, 800 Mega e Ilimitado, todos com fibra óptica pura.',
    },
    {
      question: 'Vocês oferecem suporte técnico 24/7?',
      answer: 'Sim, nosso suporte local acompanha você em todo o processo para manter sua conexão estável e segura.',
    },
    {
      question: 'Como funciona a instalação do serviço?',
      answer: 'Após a contratação, nossa equipe agenda a instalação, faz os testes e entrega a conexão pronta para uso.',
    },
    {
      question: 'Os planos possuem limite de dados?',
      answer: 'Não. Os planos são ilimitados para navegar, assistir, jogar e trabalhar sem franquia de consumo.',
    },
    {
      question: 'Vocês oferecem desconto para plano anual?',
      answer: 'Temos condições especiais em campanhas e combos. Consulte nossa equipe comercial para a oferta vigente.',
    },
    {
      question: 'Como posso pagar minha fatura?',
      answer: 'O pagamento pode ser feito pelos canais oficiais de atendimento e pelo portal do cliente.',
    },
    {
      question: 'O que acontece em caso de problema na conexão?',
      answer: 'Nossa equipe realiza diagnóstico e direciona o melhor atendimento para normalizar sua internet com agilidade.',
    },
    {
      question: 'Quais dispositivos são compatíveis com o Wi-Fi?',
      answer: 'A conexão é compatível com celulares, notebooks, computadores, smart TVs, consoles e dispositivos IoT.',
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section id="faq" className="faq-section">
      <div className="faq-header">
        <span>Dúvidas frequentes</span>
        <h2>O que você precisa saber antes de contratar</h2>
        <p>Respostas rápidas para escolher seu plano com mais segurança.</p>
      </div>

      <div className="faq">
        {faqs.map((faq, index) => (
          <button
            key={faq.question}
            type="button"
            className={`faq-item ${activeIndex === index ? 'active' : ''}`}
            onClick={() => toggleFAQ(index)}
            aria-expanded={activeIndex === index}
          >
            <span className="faq-question">
              {faq.question}
              <FiChevronRight />
            </span>
            <span className="faq-answer">
              {activeIndex === index && <span>{faq.answer}</span>}
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}

export default FAQSection;
